import { TournamentAdmin } from '@/src/domain/models';
import { useTranslation } from '@/src/i18n';
import { FlatList, Text, TouchableOpacity, View } from 'react-native';
import { AdminItem } from '../components';
import { createStyles } from '../TournamentDetailScreen.styles';

interface AdminsTabProps {
  admins: TournamentAdmin[];
  canManageAdmins: boolean;
  onAddAdmin: () => void;
  onRemoveAdmin: (admin: TournamentAdmin) => void;
  colors: {
    card: string;
    border: string;
    text: string;
    textSecondary: string;
    textTertiary: string;
    primary: string;
    primaryText: string;
    error: string;
  };
}

export const AdminsTab = ({ admins, canManageAdmins, onAddAdmin, onRemoveAdmin, colors }: AdminsTabProps) => {
  const styles = createStyles();
  const { t } = useTranslation();

  if (!canManageAdmins) {
    return (
      <View style={[styles.tabContainer, styles.centerContent]}>
        <Text style={[styles.emptyText, { color: colors.textSecondary }]}>
          {t('tournaments.onlyOwnerCanManageAdmins')}
        </Text>
      </View>
    );
  }

  return (
    <View style={styles.tabContainer}>
      <View style={styles.tabHeader}>
        <TouchableOpacity style={[styles.addAdminBtn, { backgroundColor: colors.primary }]} onPress={onAddAdmin}>
          <Text style={[styles.addAdminBtnText, { color: colors.primaryText }]}>+ {t('tournaments.addAdmin')}</Text>
        </TouchableOpacity>
      </View>

      <FlatList
        data={admins}
        keyExtractor={(item) => item.id}
        renderItem={({ item }) => (
          <AdminItem admin={item} canManageAdmins={canManageAdmins} onRemove={onRemoveAdmin} colors={colors} />
        )}
        ListEmptyComponent={
          <View style={styles.emptyContainer}>
            <Text style={[styles.emptyText, { color: colors.textSecondary }]}>{t('tournaments.noAdminsYet')}</Text>
            <Text style={[styles.emptySubtext, { color: colors.textTertiary }]}>
              {t('tournaments.noAdminsSubtext')}
            </Text>
          </View>
        }
        contentContainerStyle={styles.listContent}
      />
    </View>
  );
};
